export const submitForm = async formData => {
  const url = `${process.env.NEXT_PUBLIC_CMS_BASE_URL}/enquiry-forms`
  return new Promise((resolve, reject) => {
    try {
      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        mode: 'cors',
        body: JSON.stringify({ data: formData })
      })
        .then(response => {
          if (!response.ok) {
            return response.json().then(errorData => {
              reject(errorData?.error?.message)
            })
          }
        })
        .then(() => {
          resolve(true)
        })
        .catch(error => {
          reject(error)
        })
    } catch (error) {
      reject(new Error(`System error: ${error}`))
    }
  })
}

export const submitReferralForm = async formData => {
  const url = `${process.env.NEXT_PUBLIC_CMS_BASE_URL}/referral-forms`
  return new Promise((resolve, reject) => {
    try {
      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        mode: 'cors',
        body: JSON.stringify({ data: formData })
      })
        .then(response => {
          if (!response.ok) {
            return response.json().then(errorData => {
              reject(errorData?.error?.message)
            })
          }
        })
        .then(() => {
          resolve(true)
        })
        .catch(error => {
          reject(error)
        })
    } catch (error) {
      reject(new Error(`System error: ${error}`))
    }
  })
}
